{
  "instances": {
    "quartz": {
      "actions": "Acciones",
      "active_triggers": "Disparadores Activos",
      "associated_triggers": "Disparadores Asociados",
      "associated_with_calendar": "Asociado con calendario",
      "basic_information": "Información Básica",
      "calendar": "Calendario",
      "class": "Clase",
      "configuration": "Configuración",
      "cron_expression": "Expresión Cron",
      "custom_trigger": "Disparador Personalizado",
      "days_of_week": "Días de la Semana",
      "description": "Descripción",
      "details": "Detalles",
      "disabled": "Deshabilitado",
      "durable": "Duradero",
      "enabled": "Habilitado",
      "end_time": "Hora de Fin",
      "final_fire_time": "Tiempo Final de Disparo",
      "friday": "Viernes",
      "group": "Grupo",
      "infinite": "Infinito",
      "interval": "Intervalo",
      "job_data": "Datos del Trabajo",
      "job_name": "Nombre del Trabajo",
      "jobs": "Trabajos",
      "key": "Clave",
      "label": "Quartz",
      "last_fire": "Último Disparo",
      "last_fire_time": "Último Tiempo de Disparo",
      "monday": "Lunes",
      "name": "Nombre",
      "next_fire": "Próximo Disparo",
      "next_fire_time": "Próximo Tiempo de Disparo",
      "no": "No",
      "no_data": "No hay información de Quartz disponible",
      "paused_triggers": "Disparadores Pausados",
      "preserve_hour_of_day": "Preservar Hora del Día",
      "priority": "Prioridad",
      "recovery": "Recuperación",
      "repeat_count": "Número de Repeticiones",
      "request_recovery": "Solicitar Recuperación",
      "saturday": "Sábado",
      "schedule_configuration": "Configuración del Horario",
      "skip_day_if_hour_does_not_exist": "Omitir Día si la Hora No Existe",
      "start_time": "Hora de Inicio",
      "state": "Estado",
      "sunday": "Domingo",
      "system_default": "Predeterminado del Sistema",
      "thursday": "Jueves",
      "time_window": "Ventana de Tiempo",
      "time_zone": "Zona Horaria",
      "times_triggered": "Veces Disparadas",
      "timing_information": "Información de Tiempo",
      "total": "total",
      "trigger_data": "Datos del Disparador",
      "trigger_failed": "Error al activar",
      "trigger_failed_message": "Error al activar el trabajo: {error}",
      "trigger_failed_notification": "Error al activar el trabajo \"{jobName}\": {error}",
      "trigger_fire_times": "Tiempos de Disparo",
      "trigger_job_now": "Ejecutar Trabajo Ahora",
      "trigger_success_message": "Trabajo \"{jobName}\" activado exitosamente",
      "trigger_success_title": "Trabajo Activado",
      "triggers": "Disparadores",
      "tuesday": "Martes",
      "type": "Tipo",
      "value": "Valor",
      "wednesday": "Miércoles",
      "yes": "Sí"
    }
  }
}
